// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import {show_free_plan_promo} from '../dashboard/utils';
import {use_prices} from '../plans/use_prices';
import {i_button_props} from '../../../../hola/pub/lib/button';
import {use_app_context} from '../../lib/app_context';
import {get_new_link} from '../../../../hola/pub/lib/use_pathname';

type i_product_card_cta =
    Pick<i_button_props, 'caption' | 'to' | 'size' | 'on_click'>;

interface i_use_show_promo {
    show_promo: boolean;
    get_cta: (type?: Proxy_type)=>Partial<i_product_card_cta>;
}

const get_pricing_url = (type?: Proxy_type): string=>{
    switch (type)
    {
        case Proxy_type.DDC:
            return get_new_link('/pricing/dedicated-data-center-proxies');
        case Proxy_type.SDC:
            return get_new_link('/pricing/shared-data-center-proxies');
        case Proxy_type.RES:
            return get_new_link('/pricing/residential-proxies');
        case Proxy_type.ISPPREM:
            return get_new_link('/pricing/search-engine-isp-proxies');
        case Proxy_type.ISP:
            return get_new_link('/pricing/isp-proxies');
        default:
            return get_new_link('/pricing');
    }
};

export const use_show_promo = (): i_use_show_promo=>{
    const {dashboard} = use_app_context();
    const {info} = dashboard;
    const {prices} = use_prices();
    const show_promo = dashboard.info.inited &&
        !info.zone_groups?.length &&
        show_free_plan_promo(info.orders, info.free_zone_params);
    const get_cta = (type?: Proxy_type): Partial<i_product_card_cta>=>{
        if (show_promo)
        {
            return {
                caption: 'Try for free >',
                to: `/dashboard/page/plans?selected_type=${type}`,
                size: 'sm'
            };
        }
        const p = prices[type];
        const val = p?.ips_amount?.[0]
            ? `${p.min_price_per_ip}/IP`
            : `${p.min_price_per_gb}/GB`;
        return {
            caption: `Starting at $${val}`,
            to: get_pricing_url(type),
            size: 'sm'
        };
    };
    return {show_promo, get_cta};
};
